<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left">
        {{ video.title }}
      </div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>
    <bunny-video-card :src="video.src" :title="video.title">
      {{ video?.subtitle2 ?? '' }}
      <br><br>
    </bunny-video-card>
  </f7-sheet>
</template>

<script>

  import YtVideoCard from "./YtVideoCard.vue";
  import BunnyVideoCard from "./BunnyVideoCard.vue";
  export default {
    components: {BunnyVideoCard, YtVideoCard},

    props: ['video', 'show'],

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      //
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
